import { nonCorporateImgs } from "../../../assets/imgs/nonCorporate";
import EnquiryForm from "../../../component/Reusable/EnquiryForm";
import Help from "../../../component/Reusable/Help";
import Offer from "../../../component/Reusable/Offer";
import ThreePoints from "../../../component/Reusable/ThreePoints";
import ReusableHero from "../../../component/Reusable/ReusableHero";
import { offerData } from "../offerData";
import bgs from "../../../assets/bgs";

const Services = () => {
  const heroContents = {
    type: 1,
    title: <h1>Non-Corporate Services</h1>,
    text: (
      <p>
        This section provides our Members advice, examines different ways of
        working and provides an introduction to service charges and discusses
        the various ways in which a business may occupy commercial property.
      </p>
    ),
    img: nonCorporateImgs.servicesHero,
    mobileimg: bgs.nonCorporateServicesHeroBgMobile,
    button: true,
  };

  const offerContents = Object.values(offerData).filter(
    (el) => el.title !== "Business Rates" && el.title !== "Dispute Resolution",
  );

  return (
    <>
      <ReusableHero contents={heroContents} />
      <ThreePoints />
      <Offer
        title="Similar Services"
        contents={offerContents}
      />
      <Help />
      <EnquiryForm />
    </>
  );
};

export default Services;
